import React from 'react'
import styled from 'styled-components/macro'
import { prop } from 'styled-tools'
import FieldHelp from '../FieldHelp'

const FieldListFieldWrapper = styled.div`
  flex: ${prop('flex', 1)};
  margin: 0 0.5em;
`

function FieldListField({
  flex,
  error,
  help,
  children
}) {
  return (
    <FieldListFieldWrapper flex={flex}>
      {children}
      {help && <FieldHelp error={error}>{help}</FieldHelp>}
    </FieldListFieldWrapper>
  )
}

export default FieldListField
